<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('INDEX.form_label_material_search') ||
                  '物料批次编号/物料批次类型/批次物料名称/批次物料规格/订单编号/产品编号/客户名称/供应商名称 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="900px"
      top="10vh"
      :close-on-click-modal="false"
      v-el-dialog-drag
      append-to-body
    >
      <el-form ref="form" :model="form" label-position="top" size="mini">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_materialBatchNo') || '物料批次编号'"
              prop="materialBatchNo"
            >
              <el-input v-model="form.materialBatchNo" clearable maxlength="50">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.table_label_materialBatchType') || '物料批次类型'
              "
            >
              <dict-select
                v-model="form.materialBatchTypeList"
                url="/sys/common/dict/system"
                :body="{ dictType: 'materialBatchType' }"
                size="mini"
                clearable
                multiple
                filterable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.table_label_ncMaterialNo') || 'NC物料编码'">
              <el-input v-model="form.ncMaterialNo" clearable> </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_materialBatchUnit') || '物料单位'"
            >
              <el-input v-model="form.materialBatchUnit" clearable> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              size="mini"
              :label="$l('INDEX.table_label_customer_name') || '客户名称'"
            >
              <dict-select
                clearable
                v-model="form.custCodeList"
                filterable
                multiple
                size="mini"
                url="/master/common/dict/customerSelect"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.table_label_production_order_scm_name') ||
                  '供应商名称'
              "
            >
              <dict-select
                size="mini"
                clearable
                filterable
                v-model="form.scmCodeList"
                multiple
                url="/master/common/dict/scmPartners"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_order_no') || '订单编号'"
              prop="orderNo"
            >
              <el-input v-model="form.orderNo" clearable maxlength="50">
              </el-input>
            </el-form-item>
          </el-col> -->

          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.table_label_production_order_goods_no') || '产品编号'
              "
              prop="orderGoodsNo"
            >
              <el-input v-model="form.orderGoodsNo" clearable maxlength="50">
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-row :gutter="0">
              <el-form-item :label="$l('INDEX.quantity') || '数量'">
                <el-col :span="11">
                  <el-input-number
                    v-model="form.quantityStart"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width:100%"
                    :precision="4"
                    :max="9999999999999.9999"
                    :min="0"
                    v-el-inputnumber-default0
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.quantityEnd"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width:100%"
                    :max="9999999999999"
                    :min="0"
                    v-el-inputnumber-default0
                    :step="1"
                  ></el-input-number>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row :gutter="0">
              <el-form-item :label="$l('INDEX.table_label_taxRate') || '税率'">
                <el-col :span="11">
                  <el-input-number
                    v-model="form.taxRateStart"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width: 100%"
                    :precision="2"
                    :max="999.99"
                    :min="0"
                    v-el-inputnumber-default0
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.taxRateEnd"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width: 100%"
                    :precision="2"
                    :max="999.99"
                    :min="0"
                    v-el-inputnumber-default0
                    :step="0.01"
                  ></el-input-number>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="8">
            <el-row :gutter="0">
              <el-form-item
                :label="
                  $l('INDEX.table_label_unitPriceTaxIncluded') || '含税单价'
                "
              >
                <el-col :span="11">
                  <el-input-number
                    v-model="form.unitPriceTaxIncludedStart"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width:100%"
                    :precision="4"
                    :max="9999999999999.9999"
                    :min="0"
                    v-el-inputnumber-default0
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.unitPriceTaxIncludedEnd"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width:100%"
                    :precision="4"
                    :max="9999999999999.9999"
                    :min="0"
                    v-el-inputnumber-default0
                    :step="0.01"
                  ></el-input-number>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('INDEX.table_label_unitPrice') || '不含税单价'"
              >
                <el-col :span="11">
                  <el-input-number
                    v-model="form.unitPriceStart"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width:100%"
                    :precision="4"
                    :max="9999999999999.9999"
                    :min="0"
                    v-el-inputnumber-default0
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.unitPriceEnd"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width:100%"
                    :precision="4"
                    :max="9999999999999.9999"
                    :min="0"
                    v-el-inputnumber-default0
                    :step="0.01"
                  ></el-input-number>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('INDEX.table_label_aoumntTaxIncluded') || '含税金额'"
              >
                <el-col :span="11">
                  <el-input-number
                    v-model="form.aoumntTaxIncludedStart"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width:100%"
                    :precision="4"
                    :max="9999999999999.9999"
                    :min="0"
                    v-el-inputnumber-default0
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.aoumntTaxIncludedEnd"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width:100%"
                    :precision="4"
                    :max="9999999999999.9999"
                    :min="0"
                    v-el-inputnumber-default0
                    :step="0.01"
                  ></el-input-number>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="8">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('INDEX.table_label_aoumnt') || '不含税金额'"
              >
                <el-col :span="11">
                  <el-input-number
                    v-model="form.aoumntStart"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width:100%"
                    :precision="4"
                    :max="9999999999999.9999"
                    :min="0"
                    v-el-inputnumber-default0
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.aoumntEnd"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width:100%"
                    :precision="4"
                    :max="9999999999999.9999"
                    :min="0"
                    v-el-inputnumber-default0
                    :step="0.01"
                  ></el-input-number>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="24">
            <el-form-item
              :label="
                $l('INDEX.table_label_materialBatchName') || '批次物料名称'
              "
              prop="materialBatchName"
            >
              <el-input
                v-model="form.materialBatchName"
                type="textarea"
                clearable
                rows="1"
                maxlength="500"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="
                $l('INDEX.table_label_materialBatchSpec') || '批次物料规格'
              "
              prop="materialBatchSpec"
            >
              <el-input
                v-model="form.materialBatchSpec"
                type="textarea"
                clearable
                rows="1"
                maxlength="500"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="
                $l('INDEX.table_label_materialBatchDisplayName') ||
                  '物料显示名称'
              "
              prop="materialBatchDisplayName"
            >
              <el-input
                v-model="form.materialBatchDisplayName"
                type="textarea"
                clearable
                rows="1"
                maxlength="500"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
